export class VuelidateValidationClass {
    static validations(param, ...args) { return {}; }
    static errors($this, prop, ...args) { return []; }
}
